
import { defineComponent, PropType } from "vue";
import ButtonVue from "../ui/Button.vue";

export default defineComponent({
  name: "Modal",
  components: { appButton: ButtonVue },
  props: {
    title: String,
    content: String,
    dismiss: {
      type: Function as PropType<(ev: Event) => void>,
      required: true,
    },
    actions: Object as PropType<
      Array<{
        label: string;
        handler: (ev: MouseEvent) => void;
      }>
    >,
  },
  setup() {
    const focusable: HTMLElement[] = [];
    const prevActiveElement = document.activeElement;

    return { focusable, prevActiveElement };
  },

  methods: {
    handleKeyDown(ev: KeyboardEvent) {
      var KEY_TAB = 9;
      var KEY_ESC = 27;

      const handleBackwardTab = () => {
        if (document.activeElement === this.focusable[0]) {
          ev.preventDefault();
          this.focusable[this.focusable.length - 1].focus();
        }
      };
      const handleForwardTab = () => {
        if (
          document.activeElement === this.focusable[this.focusable.length - 1]
        ) {
          ev.preventDefault();
          this.focusable[0].focus();
        }
      };

      switch (ev.keyCode) {
        case KEY_TAB:
          if (this.focusable.length === 1) {
            ev.preventDefault();
            break;
          }

          if (ev.shiftKey) {
            handleBackwardTab();
          } else {
            handleForwardTab();
          }

          break;
        case KEY_ESC:
          this.dismiss(ev);
          break;
        default:
          break;
      }
    },
  },

  mounted() {
    const focusable = (
      this.$refs.modal as HTMLDivElement
    ).querySelectorAll<HTMLElement>(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );
    focusable[0].focus();

    this.focusable = [...focusable];
  },

  unmounted() {
    if (this.prevActiveElement) {
      (this.prevActiveElement as HTMLElement).focus();
    }
  },
});
